import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_ResetPasswordForm = _resolveComponent("ResetPasswordForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PageTitle, { class: "mb-4" }, {
      default: _withCtx(() => [
        _createTextVNode("Set your password")
      ]),
      _: 1
    }),
    _createVNode(_component_ResetPasswordForm, {
      onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'login' })))
    })
  ], 64))
}